import AppTable from 'shared/common/Table/ui/AppTable'
import { apiEndpoints } from 'shared/model/apiEndpoints'

import { useNavigate } from 'react-router-dom'

import { accessManageColumns } from 'modules/AccessManage/model/accessManageColumns'
import {
  usersFilters,
  usersParams,
} from 'modules/AccessManage/model/tableFilters'
import { AccessManageTableData } from 'modules/AccessManage/types'
import AccessManageFilter from 'modules/AccessManage/ui/AccessManageFilter'

import PrimaryButton from 'shared/ui/PrimaryButton'
import Title from 'shared/ui/Title'

const AccessManageMain = () => {
  const navigate = useNavigate()

  const handleRowClick = (record: AccessManageTableData) => {
    navigate(`${record.id}`)
  }

  return (
    <div>
      <div className="flex justify-between items-center py-[12px]">
        <Title
          className="!mb-0 !font-bold !leading-[32px] !text-dark_2"
          level={3}
        >
          Управление доступами
        </Title>
        <PrimaryButton
          text="Добавить пользователя"
          onClick={() => navigate('add-user')}
        />
      </div>
      <AppTable<AccessManageTableData>
        apiUrl={apiEndpoints.users}
        columns={accessManageColumns}
        filterParams={usersParams}
        onRow={(record) => {
          return {
            onClick: () => handleRowClick(record),
          }
        }}
        className="clickable"
        headerFiltersProps={{
          placeholder: 'Поиск по имени, почте',
          withRangeDate: false,
          filtersKeys: usersFilters,
          params: usersParams,
          filters: <AccessManageFilter />,
        }}
      />
    </div>
  )
}

export default AccessManageMain
